import { appSetFromDate, appSetToDate } from "store/actions/appAction";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDidUpdateEffect from "./useDidUpdateEffect";

export default function useDateState(activeTab?: any) {
  const dispatch = useDispatch();
  const paginationState = useSelector((state: any) => state.paginationReducer);
  const [fromToDate, setFromToDate] = useState({ fromDate: "", toDate: "" })
  const token = useSelector((state: any) => state.businessReducer.business?.token);
  const setFromDate = (fromDate: any) => dispatch(appSetFromDate(fromDate));
  const setToDate = (toDate: any) => dispatch(appSetToDate(toDate));
  let location = window.location;

  useDidUpdateEffect(() => {
    handleDateFilter();
  }, [fromToDate]);

  const handleDateFilter = () => {
    if (activeTab) {
      let { search, sort } = paginationState;
      let options: any = {};
      if (fromToDate.fromDate && fromToDate.toDate) {
        options = {
          "subColumn": "date",
          "searchText": fromToDate.fromDate,
          "searchTextAlt": fromToDate.toDate,
        }
      }
      dispatch(
        activeTab.actions.fetch({
          pagination: paginationState,
          search,
          sort,
          token,
          options,
          location,
        })
      );
    }
  };

  function setDates(dates?: string[]) {
    if (dates) {
      setFromToDate({ fromDate: dates[0], toDate: dates[1] })
      setFromDate(dates[0]);
      setToDate(dates[1]);
    } else {
      setFromToDate({ fromDate: "", toDate: "" })
      setFromDate(undefined);
      setToDate(undefined);
    }
  }

  return { setFromDate, setToDate, handleDateFilter, setDates, toDate: fromToDate.toDate, fromDate: fromToDate.fromDate };
}
